import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    allDenominators (request) {
      return api.post('/denominators/full', request)
    },

    allToolsUsage (request) {
      return api.post('/sheet/toolsusage/full', request)
    }
  }
} else {
  module = {

    allDenominators (request) {
      return delay(1500)({
        data: {
          err: 'Erreur au chargement des fiches.'
        }
      })
    }
  }
}

export default module
